function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M507.785,146.242L260.318,1.175c-2.603-1.519-5.803-1.57-8.439-0.111L4.412,137.598C1.69,139.091,0,141.958,0,145.064 v358.4c0,4.719,3.823,8.533,8.533,8.533H51.2c4.71,0,8.533-3.814,8.533-8.533V204.798h392.533v298.667 c0,4.719,3.814,8.533,8.533,8.533h42.667c4.719,0,8.533-3.814,8.533-8.533V153.598C512,150.568,510.396,147.769,507.785,146.242z  M494.933,494.931h-25.6V196.264c0-4.71-3.814-8.533-8.533-8.533H51.2c-4.71,0-8.533,3.823-8.533,8.533v298.667h-25.6V150.099 L255.872,18.344l239.061,140.143V494.931z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M426.667,392.531h-102.4c-4.719,0-8.533,3.814-8.533,8.533v102.4c0,4.719,3.814,8.533,8.533,8.533h102.4 c4.719,0,8.533-3.814,8.533-8.533v-102.4C435.2,396.345,431.386,392.531,426.667,392.531z M418.133,494.931H332.8v-85.333h85.333 V494.931z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M384,401.064v25.6h-17.067v-25.6h-17.067v34.133c0,4.719,3.814,8.533,8.533,8.533h34.133c4.719,0,8.533-3.814,8.533-8.533 v-34.133H384z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M324.267,392.531h-102.4c-4.71,0-8.533,3.814-8.533,8.533v102.4c0,4.719,3.823,8.533,8.533,8.533h102.4 c4.719,0,8.533-3.814,8.533-8.533v-102.4C332.8,396.345,328.986,392.531,324.267,392.531z M315.733,494.931H230.4v-85.333h85.333 V494.931z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M281.6,401.064v25.6h-17.067v-25.6h-17.067v34.133c0,4.719,3.823,8.533,8.533,8.533h34.133 c4.719,0,8.533-3.814,8.533-8.533v-34.133H281.6z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M426.667,290.131h-102.4c-4.719,0-8.533,3.814-8.533,8.533v102.4c0,4.719,3.814,8.533,8.533,8.533h102.4 c4.719,0,8.533-3.814,8.533-8.533v-102.4C435.2,293.945,431.386,290.131,426.667,290.131z M418.133,392.531H332.8v-85.333h85.333 V392.531z"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M384,298.664v25.6h-17.067v-25.6h-17.067v34.133c0,4.719,3.814,8.533,8.533,8.533h34.133c4.719,0,8.533-3.814,8.533-8.533 v-34.133H384z"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 51.2,
  y: 255.998,
  width: 409.6,
  height: 17.067
})));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 51.2,
  y: 221.864,
  width: 409.6,
  height: 17.067
})));

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M298.667,119.464h-85.333c-4.71,0-8.533,3.823-8.533,8.533v34.133c0,4.71,3.823,8.533,8.533,8.533h85.333 c4.719,0,8.533-3.823,8.533-8.533v-34.133C307.2,123.287,303.386,119.464,298.667,119.464z M290.133,153.598h-68.267v-17.067 h68.267V153.598z"
})));

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

function SvgWh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWh);
export default __webpack_public_path__ + "static/media/wh.670520e4.svg";
export { ForwardRef as ReactComponent };